import { Card, Form } from 'ui';
import { JoinedProgramsListContent } from './joined-programs-list-content';
import { JoinedProgramsListFilters, type JoinedProgramsListFiltersFormValues } from './joined-programs-list-filters';

type FormValues = JoinedProgramsListFiltersFormValues;

type P = {
  getPathToProgramDetail: (id: string) => string;
};

const JoinedProgramsList = ({ getPathToProgramDetail }: P) => (
  <Card>
    <Form<FormValues> noOptional>
      <JoinedProgramsListFilters />
      <Form.Item<FormValues> noStyle shouldUpdate={(previous, current) => previous.search !== current.search}>
        {({ getFieldsValue }) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          const { search } = getFieldsValue(true) as FormValues;

          return (
            <JoinedProgramsListContent
              filter={{
                search,
              }}
              getPathToProgramDetail={getPathToProgramDetail}
            />
          );
        }}
      </Form.Item>
    </Form>
  </Card>
);

export default JoinedProgramsList;
